import React, { useContext, useEffect, useRef, useState } from "react";
import "./form.css";
import Swal from "sweetalert2";
import { Button } from "@material-ui/core";
import { Context } from "../../../context/Context";
import { useHistory } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";

const Prices = ({ newAgent, newReservation, arriveData, setArriveData }) => {
  const { token } = useContext(Context);
  const date = new Date().toISOString().substr(0, 10);
  const week = new Date().getTime() + 86400000 * 7;
  const nextWeek = new Date(week).toISOString().substr(0, 10);

  const [leaveData, setLeaveData] = useState(nextWeek);
  const [leave, setLeave] = useState(new Date().toISOString().substr(0, 10));
  const [price, setPrice] = useState();
  const [priceData, setPriceData] = useState([]);
  const [checkboxTerm, setcheckboxTerm] = useState(false);

  const history = useHistory();
  const { dispatch, user } = useContext(Context);
  const recaptchaRef = useRef();
  //agent
  const login = useRef("");
  const password = useRef("");
  const agentName = useRef("");
  const agentSurname = useRef("");
  const agentEmail = useRef("");
  const agentNumber = useRef("");
  //reservation
  const name = useRef("");
  const surname = useRef("");
  const countOfPeople = useRef("");
  const email = useRef("");
  const phone = useRef("");
  const carId = useRef("");
  const destination = useRef("");
  const [arriveHour, setArriveHour] = useState("12:00");
  const [leaveHour, setLeaveHour] = useState("12:00");
  const companyName = useRef("");
  const nip = useRef("");

  const handleCheckboxTerm = (e) => {
    setcheckboxTerm(e.target.checked);
  };
  const handleChangeArriveHour = (e) => {
    setArriveHour(e.target.value);
  };
  const handleChangeLeaveHour = (e) => {
    setLeaveHour(e.target.value);
  };

  useEffect(() => {
    const getMonth = async () => {
      const months = await axios.get(
        "https://www.rezerwacjaparkingu.com/backend_artlot/api/months"
      );
      const monthIndex = arriveData.slice(5, 7);
      const month = months.data.filter((m) => m.id === monthIndex);
      setPriceData(month);
    };
    getMonth();
  }, [arriveData]);

  const handleChangeInfo = (e) => {
    switch (e.target.id) {
      case "arriveData":
        setArriveData(e.target.value);
        break;
      case "leaveData":
        setLeaveData(e.target.value);
        break;
      default:
        console.log("something wrong");
    }
  };

  useEffect(() => {
    const tomarrow = new Date(arriveData).getTime() + 86400000;
    const week = new Date(arriveData).getTime() + 86400000 * 7;
    const tomarrowDate = new Date(tomarrow).toISOString().substr(0, 10);
    const nextWeek = new Date(week).toISOString().substr(0, 10);
    let miliseconds =
      new Date(leaveData).getTime() - new Date(arriveData).getTime();
    let days = miliseconds / 86400000;
    setLeave(tomarrowDate);
    if (days <= 0) {
      setLeaveData(nextWeek);
    }
    setLeave(tomarrowDate);
  }, [arriveData, leaveData]);

  useEffect(() => {
    const arrival = arriveHour.length === 4 ? `0${arriveHour}` : arriveHour;
    const leaval = leaveHour.length === 4 ? `0${leaveHour}` : leaveHour;
    let miliseconds =
      new Date(`${leaveData}T${leaval}`).getTime() -
      new Date(`${arriveData}T${arrival}`).getTime();
    let days = miliseconds / 86400000;
    days = Math.ceil(days);
    switch (days) {
      case 1:
        setPrice(priceData?.[0]?.firstDay);
        break;
      case 2:
        setPrice(priceData?.[0]?.secondDay);
        break;
      case 3:
        setPrice(priceData?.[0]?.thirdDay);
        break;
      case 4:
        setPrice(priceData?.[0]?.fourthDay);
        break;
      case 5:
        setPrice(priceData?.[0]?.fifthDay);
        break;
      case 6:
        setPrice(priceData?.[0]?.sixthDay);
        break;
      case 7:
        setPrice(priceData?.[0]?.seventhDay);
        break;
      case 8:
        setPrice(priceData?.[0]?.eighthDay);
        break;
      default:
        break;
    }
    if (days > 8) {
      console.log(days);
      setPrice(priceData?.[0].eighthDay + priceData?.[0].nextDay * (days - 8));
    }
  }, [arriveData, leaveData, priceData, arriveHour, leaveHour]);

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    window.sessionStorage.clear();
    console.log(token);
    const reservation = {
      username: name.current.value,
      surname: surname.current.value,
      count: countOfPeople.current.value,
      email: email.current.value,
      number: phone.current.value,
      destination:
        destination.current.value === ""
          ? "nie podano"
          : destination.current.value.trim(),
      arriveData: arriveData,
      leaveData: leaveData,
      arriveHour: arriveHour,
      leaveHour: leaveHour,
      carId: carId.current.value,
      price: price,
      company: companyName.current.value,
      NIP: nip.current.value,
      tokenRe: token,
    };
    if (!newReservation) {
      try {
        const res = await axios.post(
          "https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/recaptcha",
          {
            token: token,
          }
        );
        if (res.data.success) {
          window.sessionStorage.setItem(
            "reservation",
            JSON.stringify(reservation)
          );
          dispatch({ type: "RESERVATION_SET", payload: reservation });
          history.push("/order");
        } else {
          alert("Recaptcha failed, try again");
        }
      } catch (err) {
        console.log(err);
      }
    }
  };
  const handleAddAgent = async (e) => {
    e.preventDefault();
    const usera = {
      username: agentName.current.value,
      login: login.current.value,
      surname: agentSurname.current.value,
      password: password.current.value,
      email: agentEmail.current.value,
      number: agentNumber.current.value,
      role: "agent",
    };
    try {
      const res = await axios.post(
        "https://www.rezerwacjaparkingu.com/backend_artlot/api/users/register",
        usera,
        {
          headers: {
            authorization: "megaparkingIGHERQHIGQRE " + token,
          },
        }
      );
      Swal.fire({
        icon: "success",
        title: `Pomyślnie dodano agenta, ${res.data.login}`,
        text: "Jego statystyki będą widoczne w panelu",
        confirmButtonColor: "#1267a2",
      }).then(() => {
        window.location.reload();
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: `Nazwa użytkownika jest zajęta`,
        confirmButtonColor: "#1267a2",
      });
    }
  };

  const handleNewAgentReservation = async (e) => {
    e.preventDefault();
    window.sessionStorage.removeItem("reservation");
    const reservation = {
      username: name.current.value,
      surname: surname.current.value,
      count: countOfPeople.current.value,
      email: email.current.value,
      number: phone.current.value,
      destination: destination.current.value.trim(),
      arriveData: arriveData,
      leaveData: leaveData,
      arriveHour: arriveHour,
      leaveHour: leaveHour,
      carId: carId.current.value,
      price: price,
      company: companyName.current.value,
      NIP: nip.current.value,
      agent: user.username,
    };
    try {
      await axios.post(
        "https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations",
        reservation
      );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Dziękujemy za złożenie rezerwacji",
        footer: "Rezerwacja dodana do Twojego konta",
        confirmButtonText: "Powrót",
        confirmButtonColor: "#1267a2",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    } catch (err) {
      console.log(err);
    }
  };
  let body;

  if (newAgent) {
    body = (
      <div className="wrapperForm" style={{ marginTop: "100px" }}>
        <h3>Dodaj nowego agenta</h3>
        <hr />
        <form onSubmit={handleAddAgent}>
          <div className="formRow">
            <div className="inputL">
              <span>Login *</span>
              <input type="text" ref={login} required minLength="3" />
            </div>
            <div className="inputR">
              <span>Hasło *</span>
              <input type="password" ref={password} required minLength="6" />
            </div>
          </div>
          <div className="formRow">
            <div className="inputL">
              <span>Imię *</span>
              <input type="text" ref={agentName} required minLength="3" />
            </div>
            <div className="inputR">
              <span>Nazwisko *</span>
              <input type="text" ref={agentSurname} required minLength="3" />
            </div>
          </div>
          <div className="formRow">
            <div className="inputL">
              <span>E-mail *</span>
              <input type="email" ref={agentEmail} required />
            </div>
            <div className="inputR">
              <span>Telefon *</span>
              <input type="number" ref={agentNumber} required minLength="8" />
            </div>
          </div>
          <br />
          <br />
          <Button
            variant="contained"
            className="button"
            color="primary"
            size="small"
            type="submit"
            style={{ backgroundColor: "#1267a2" }}
          >
            Dodaj
          </Button>
        </form>
      </div>
    );
  } else {
    body = (
      <div className="wrapperForm">
        {newReservation ? null : (
          <>
            <h3>PARKING PYRZOWICE</h3>
            <hr />
          </>
        )}
        <form
          onSubmit={
            newReservation ? handleNewAgentReservation : handleSubmitForm
          }
        >
          <div className="formRowData">
            <div className="inputL">
              <label htmlFor="arriveData">
                <span style={{ position: "relative" }}>
                  Data{" "}
                  <span style={{ position: "absolute", left: "120%" }}>
                    przyjazdu
                  </span>
                </span>
                <input
                  type="date"
                  id="arriveData"
                  value={arriveData}
                  required
                  min={date}
                  onChange={handleChangeInfo}
                />
              </label>
              <select value={arriveHour} onChange={handleChangeArriveHour}>
                <option>0:00</option>
                <option>0:30</option>
                <option>1:00</option>
                <option>1:30</option>
                <option>2:00</option>
                <option>2:30</option>
                <option>3:00</option>
                <option>3:30</option>
                <option>4:00</option>
                <option>4:30</option>
                <option>5:00</option>
                <option>5:30</option>
                <option>6:00</option>
                <option>6:30</option>
                <option>7:00</option>
                <option>7:30</option>
                <option>8:00</option>
                <option>8:30</option>
                <option>9:30</option>
                <option>10:00</option>
                <option>10:30</option>
                <option>11:00</option>
                <option>11:30</option>
                <option>12:00</option>
                <option>12:30</option>
                <option>13:00</option>
                <option>13:30</option>
                <option>14:00</option>
                <option>14:30</option>
                <option>15:00</option>
                <option>15:30</option>
                <option>16:00</option>
                <option>16:30</option>
                <option>17:00</option>
                <option>17:30</option>
                <option>18:00</option>
                <option>18:30</option>
                <option>19:00</option>
                <option>19:30</option>
                <option>20:00</option>
                <option>20:30</option>
                <option>21:30</option>
                <option>22:00</option>
                <option>22:30</option>
                <option>23:00</option>
                <option>23:30</option>
              </select>
            </div>
            <div className="inputR">
              <label htmlFor="leaveData">
                <span>Data odjazdu</span>
                <input
                  type="date"
                  id="leaveData"
                  value={leaveData}
                  required
                  min={leave}
                  onChange={handleChangeInfo}
                />
              </label>
              <select value={leaveHour} onChange={handleChangeLeaveHour}>
                <option>0:00</option>
                <option>0:30</option>
                <option>1:00</option>
                <option>1:30</option>
                <option>2:00</option>
                <option>2:30</option>
                <option>3:00</option>
                <option>3:30</option>
                <option>4:00</option>
                <option>4:30</option>
                <option>5:00</option>
                <option>5:30</option>
                <option>6:00</option>
                <option>6:30</option>
                <option>7:00</option>
                <option>7:30</option>
                <option>8:00</option>
                <option>8:30</option>
                <option>9:30</option>
                <option>10:00</option>
                <option>10:30</option>
                <option>11:00</option>
                <option>11:30</option>
                <option>12:00</option>
                <option>12:30</option>
                <option>13:00</option>
                <option>13:30</option>
                <option>14:00</option>
                <option>14:30</option>
                <option>15:00</option>
                <option>15:30</option>
                <option>16:00</option>
                <option>16:30</option>
                <option>17:00</option>
                <option>17:30</option>
                <option>18:00</option>
                <option>18:30</option>
                <option>19:00</option>
                <option>19:30</option>
                <option>20:00</option>
                <option>20:30</option>
                <option>21:30</option>
                <option>22:00</option>
                <option>22:30</option>
                <option>23:00</option>
                <option>23:30</option>
              </select>
            </div>
          </div>
          <div className="formRow">
            <div className="inputL">
              <span>Imię *</span>
              <input type="text" ref={name} required minLength="4" />
            </div>
            <div className="inputR">
              <span>Nazwisko *</span>
              <input
                type="text"
                ref={surname}
                required
                minLength="3"
                style={{ width: "calc(65% - 5px)", marginRight: "10px" }}
              />
              <span className="countOfPeople">l. osób *</span>
              <input
                type="text"
                className="countOfPeopleInput"
                ref={countOfPeople}
                required
                style={{ width: "calc(35% - 5px)" }}
              />
            </div>
          </div>
          <div className="formRow">
            <div className="inputL">
              <span>E-mail *</span>
              <input type="email" ref={email} required />
            </div>
            <div className="inputR">
              <span>Telefon *</span>
              <input type="number" ref={phone} required minLength="6" />
            </div>
          </div>
          <div className="formRow">
            <div className="inputL">
              <span>Nr. Rejestracji *</span>
              <input type="text" ref={carId} required />
            </div>
            <div className="inputR">
              <span>Kierunek</span>
              <input type="text" ref={destination} />
            </div>
          </div>
          {/* <div className="formRow">
            <div className="inputL">
              <span>Nazwa firmy</span>
              <input type="text" ref={companyName} />
            </div>
            <div className="inputR">
              <span>NIP</span>
              <input type="text" ref={nip} minLength="10" />
            </div>
          </div> */}
          <div className="settingWrapper">
            <div className="price">
              <span className="garage">Kwota do zapłaty: </span>
              <span className="amount">{price}zł</span>
            </div>
          </div>
          <div className="checkboxTerms">
            <input
              type="checkbox"
              checked={checkboxTerm}
              onChange={handleCheckboxTerm}
              required
            />
            <span>
              NINIEJSZYM WYRAŻAM ZGODĘ NA PRZETWARZANIE MOICH DANYCH OSOBOWYCH
              PRZEZ ART LOT PARKING PYRZOWICE, NA POTRZEBY I W ZAKRESIE
              NIEZBĘDNYM DO KORZYSTANIA PRZEZE MNIE Z USŁUG ŚWIADCZONYCH PRZEZ
              ART LOT, W TYM NA PRZEKAZYWANIE MOICH DANYCH OSOBOWYCH PODMIOTOM
              TRZECIM, PRZY POMOCY KTÓRYCH ART LOT ŚWIADCZY USŁUGI.
            </span>
          </div>
          <Button
            variant="contained"
            className="button"
            color="primary"
            size="small"
            type="submit"
            style={newReservation ? { backgroundColor: "#1267a2" } : {}}
          >
            Zapisz
          </Button>
          {!newReservation ? (
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6LcZHbUcAAAAAJfIMoHWhowrxZyjaEd7KyDzvBPP"
              size="invisible"
            />
          ) : null}
        </form>
      </div>
    );
  }

  return body;
};

export default Prices;
